"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typography = require("@vds-core/typography");
var _default = exports["default"] = _typography.Micro;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/typography/dist/cjs/components/Micro/Micro.js
// module id = 1626
// module chunks = 0